import { logoSize} from './theme.js';

export default function mainlogo({size, type}){
	const classNames = logoSize[size];
	return (
		<img className={classNames} alt="logo" src={`${process.env.PUBLIC_URL}/images/stacklive-logo.png`} />
	)
}
